import deDE from 'antd/lib/locale-provider/de_DE';
import enUS from 'antd/lib/locale-provider/en_US';
import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import deDEMessages from './Locales/de_DE.json';
import enUSMessages from './Locales/en_US.json';

const langConfig = {
  de: {
    messages: {
      ...deDEMessages,
    },
    antd: deDE,
    locale: 'de-DE',
    data: de,
  },
  en: {
    messages: {
      ...enUSMessages,
    },
    antd: enUS,
    locale: 'en-US',
    data: en,
  },
};

export default langConfig;
